<div
  class="flex items-start justify-between p-4 rounded-xl bg-gray-900 border border-black hover:border-gray-500"
>
  <div class="flex gap-4 overflow-hidden">
    <div class="mt-1">
      <i class="pi pi-file-pdf text-green-500 text-2xl"></i>
    </div>

    <div class="flex flex-col gap-1 overflow-hidden">
      <span class="text-base text-gray-100 font-semibold truncate">
        {{ document().fileName }}
      </span>

      <div class="flex items-center gap-2 text-xs text-gray-500">
        <span>{{ documentType() | translateDirectus: 'title' }}</span>
        <span class="text-gray-700">•</span>
        <span>{{ document().fileSize || 0 | appNumber: '1.0-1' }} KB</span>
        <span class="text-gray-700">•</span>
        <span>{{ document().createdAt | appDate }}</span>
      </div>

      <div class="flex items-center gap-2 mt-1">
        <span
          class="px-2 py-0.5 rounded-sm bg-gray-800 text-gray-200 text-[10px] font-bold"
          [pTooltip]="'common.version' | transloco"
          tooltipPosition="left"
        >
          {{ document().version }}
        </span>
        <span
          class="px-2 py-0.5 rounded-sm bg-gray-800 text-[10px] font-bold"
          [pTooltip]="'common.status' | transloco"
        >
          {{ documentStatus() | translateDirectus }}
        </span>
      </div>
    </div>
  </div>

  <div class="flex flex-col items-end gap-0">
    <div class="flex items-center">
      <p-button
        icon="pi pi-eye"
        [text]="true"
        severity="secondary"
        styleClass="p-1! h-8! w-8! hover:bg-[color-mix(in_srgb,var(--color-green),transparent_60%)]! transition-colors"
        [pTooltip]="'common.previewDocument' | transloco"
        tooltipPosition="left"
        (onClick)="previewItem.emit(document().id)"
      />
      <p-button
        icon="pi pi-download"
        [text]="true"
        severity="secondary"
        styleClass="p-1! h-8! w-8! hover:bg-[color-mix(in_srgb,var(--color-blue),transparent_60%)]! transition-colors"
        [pTooltip]="'common.download' | transloco"
        (onClick)="downloadItem.emit(document().id)"
      />
    </div>

    @if (isEditable()) {
      <div class="flex items-center">
        <p-button
          icon="pi pi-pen-to-square"
          [text]="true"
          severity="secondary"
          styleClass="p-1! h-8! w-8! hover:bg-[color-mix(in_srgb,var(--color-blue),transparent_60%)]! transition-colors"
          [pTooltip]="'common.edit' | transloco"
          tooltipPosition="left"
          (onClick)="editItem.emit(document())"
        />
        <p-button
          icon="pi pi-times"
          [text]="true"
          severity="secondary"
          styleClass="p-1! h-8! w-8! hover:bg-[color-mix(in_srgb,var(--color-red),transparent_60%)]! transition-colors"
          [pTooltip]="'common.delete' | transloco"
          (onClick)="onDelete()"
        />
      </div>
    }
  </div>
</div>
